async function updateUserData(data, urls, Formatter, Network) {
  const url = urls.updateUserData
  const response = await sendRequest(data, url, Network)
  const parsedResponse = parseResponse(response, Formatter, Network)
  return parsedResponse
}

async function sendRequest(data, url, Network) {
  const userReference = await self.servicesVars.getUserReference()
  const reqData = {
    ...data,
    id: userReference,
  }
  const header = {
    Authorization: 'Zmz$muQCQJ6rw1BLQQV2WtT#nP80fzlZef7pXAD69P!C',
  }
  const reqUrl = url + userReference
  const response = await Network.sendPostRequestWithHeader(
    reqUrl,
    header,
    reqData,
  )
  return response
}

function parseResponse(response, Formatter, Network) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201) &&
    response.response.statusCode == 200
  ) {
    const rawUser = response.response.data
    const user = Formatter.parseExternalUser(rawUser)

    return {
      success: true,
      user,
    }
  }
  if (response.status.code === 404) {
    return {
      success: false,
      messageId: 'messages.updateUserData.userNotFound',
    }
  }
  return Network.defaultResponseParsing(response)
}

export { updateUserData }
